import { memo } from "react"
import { Box, Link } from "@mui/material"
import PropTypes from "prop-types"

const ClickableMetricCell = memo(({
  enhancedValue,
  metricAction,
  item,
  metric,
  metricSignClass,
}) => {
  const handleClick = (e) => {
    e.preventDefault()
    metricAction(item, metric)
  }

  return (
    <Box className="metric-cell">
      <Link
        data-test-id={`clickable-metric-button-${metric.id}-${item.label}`}
        component="button"
        underline="hover"
        variant="body2"
        onClick={handleClick}
        className={`clickable-metric-button metric-value ${metricSignClass}`.trim()}
      >
        {enhancedValue}
      </Link>
    </Box>
  )
})

ClickableMetricCell.displayName = "ClickableMetricCell"

ClickableMetricCell.propTypes = {
  enhancedValue: PropTypes.any.isRequired,
  metricAction: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  metric: PropTypes.object.isRequired,
  metricSignClass: PropTypes.oneOf(["", "negative", "positive"]).isRequired,
}

export default ClickableMetricCell
